import createPersistedState from 'vuex-persistedstate';

export const plugins = [
    createPersistedState({
        key: 'zist.vuex',
        paths: [
            'localization.language',
        ]
    })
];


// WEBPACK FOOTER //
// ./src/store/plugins.js